import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '@components/layout/MainLayout';
import ErrorBoundary from '@shared/components/ErrorBoundary';
import { PageSkeleton } from '@shared/components/ui/PageSkeleton';

// Lazy loaded — heavy page components
const NewDealWizard = React.lazy(() => import('@features/deals/components/NewDealWizard'));
const DealList = React.lazy(() => import('@features/deals/components/DealList'));
const DealDetails = React.lazy(() => import('@features/deals/components/DealDetails'));
const PipelineAnalytics = React.lazy(() => import('@features/deals/components/pipeline/PipelineAnalytics'));

export const dealRoutes = [
  <Route
    key="deals"
    path="/deals"
    element={
      <MainLayout>
        <ErrorBoundary feature="Deal Pipeline">
          <Suspense fallback={<PageSkeleton />}>
            <DealList />
          </Suspense>
        </ErrorBoundary>
      </MainLayout>
    }
  />,
  <Route
    key="deals-analytics"
    path="/deals/analytics"
    element={
      <MainLayout>
        <ErrorBoundary feature="Deal Pipeline">
          <Suspense fallback={<PageSkeleton />}>
            <PipelineAnalytics />
          </Suspense>
        </ErrorBoundary>
      </MainLayout>
    }
  />,
  <Route
    key="deal-details"
    path="/deals/:dealId"
    element={
      <MainLayout>
        <ErrorBoundary feature="Deal Pipeline">
          <Suspense fallback={<PageSkeleton />}>
            <DealDetails />
          </Suspense>
        </ErrorBoundary>
      </MainLayout>
    }
  />,
  <Route
    key="new-deal"
    path="/new-deal"
    element={
      <MainLayout>
        <ErrorBoundary feature="Deal Pipeline">
          <Suspense fallback={<PageSkeleton />}>
            <NewDealWizard />
          </Suspense>
        </ErrorBoundary>
      </MainLayout>
    }
  />
];

export default dealRoutes;
